import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Document} from '../../../user/model/Document';
import {Constant} from '../../../global/util/Constant';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {StringUtil} from '../../../global/util/StringUtil';
import {NgbDateStructUtil} from '../../../global/util/NgbDateStructUtil';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {TranslateService} from '@ngx-translate/core';
import {PersonService} from '../../../user/service/person.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-signed-document-viewer',
    templateUrl: './identity-validation-sign.component.html',
    styleUrls: ['./identity-validation-sign.component.css']
})
export class IdentityValidationSignComponent implements OnInit {
    public identityForm: FormGroup;
    public checkDigit: string;
    public lastName: string;
    public lastName2: string;
    public name: string;
    public birthLocation: string;
    public isPublic = true;
    public birthDate: string;
    public fatherName: string;
    public motherName: string;
    public registrationDate: string;
    public issueDate: string;
    public single = 'SOLTERO';
    public married = 'CASADO';
    public widower = 'VIUDO';
    public divorced = 'DIVORCIADO';
    public civilStatus = 'SOLTERO';
    public male = '';
    public female = '';
    public gender = '';
    public listValues: string[] = [];
    public values4validation: any[] = [];
    public person: any;
    public document: Document;
    public receivedPerson: any;
    public receivedDocument: any;
    public hashIdentifier: any;
    public personId: number;
    public messageAlert = '';
    public alertType = 'alert-danger';
    public icon: string;
    public showError = false;
    public loading: boolean;

    constructor(public translate: TranslateService,
                private formBuilder: FormBuilder,
                public personService: PersonService,
                private modalService: NgbModal,
                private route: Router,
                private activatedRoute: ActivatedRoute) {
        this.receiveParams();
    }

    ngOnInit(): void {
        this.person = history.state.person;
        this.document = history.state.document;
        // this.isPublic = history.state.isPublic;
        if (!this.person) {
            this.back();
        }
        this.male = 'MASCULINO';
        this.female = 'FEMENINO';
        this.gender = 'MASCULINO';
        this.createForm();
        this.setRequiredFormControl();
    }

    public receiveParams() {
        this.activatedRoute.params.subscribe(params => {
            this.hashIdentifier = params.hashIdentifier;
            this.personId = +params.personId;
        });
    }

    accept() {
        this.showError = false;
        if (this.identityForm.invalid) {
            this.markAsTouchedAllControls();
            return;
        }
        const checkedWorkflows = this.prepare4validation();
        this.person.valuesidentity = checkedWorkflows;
        let urlPerson;
        if (this.isPublic) {
            urlPerson = Constant.ROOT_API_V1.concat('/public/people/identity?uuid=', this.document._more.uuid);
        } else {
            urlPerson = Constant.ROOT_API_V1.concat('/people/identity');
        }
        this.loading = true;
        this.personService.verifyIdentity(urlPerson, this.person).subscribe((next: any) => {
            const result = next;
            this.loading = false;
            if (result.identityValidation) {
                this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/viewer/'], {
                    state: {
                        document: this.document,
                        person: this.person
                    }
                }).then();
            } else {
                this.loading = false;
                this.showError = true;
                this.showMessage('alert-warning', 'fa fa-exclamation-triangle', this.translate.instant('MESSAGE.FAILED-IDENTITY-VALIDATION'));
            }
        }, error => {
            if (error.status) {
                this.loading = false;
                this.showError = true;
                if (HttpStatusCode.NOT_FOUND === error.status) {
                    this.showMessage('alert-danger', 'fa fa-exclamation-circle', error.error.message);
                } else if (HttpStatusCode.CONFLICT === error.status) {
                    this.showMessage('alert-danger', 'fa fa-exclamation-circle', error.error.message);
                } else if (HttpStatusCode.FAILED_DEPENDENCY === error.status) {
                    this.showMessage('alert-danger', 'fa fa-exclamation-circle', error.error.message);
                } else if (HttpStatusCode.INTERNAL_SERVER_ERROR === error.status) {
                    this.showMessage('alert-danger', 'fa fa-exclamation-circle', error.error.message);
                } else {
                    this.showMessage('alert-danger', 'fa fa-exclamation-circle', this.translate.instant('TITLE.SIGNATURE-DOCUMENTS') + error.error.message);
                }
            }
        });
    }

    private prepare4validation(): string {
        let value = '';
        for (const values of this.listValues) {
            const description = this.valueDescription(values);
            value += ''
                .concat(description)
                .concat(',')
                .concat(this.getValue4identityValidation(values))
                .concat('|');
        }
        return StringUtil.removeLastCharacter(value);
    }

    private markAsTouchedAllControls() {
        Object.values(this.identityForm.controls).forEach(control => {
            control.markAsTouched();
        });
    }

    // Regresar a la pantalla anterior
    back() {
        this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/sign']).then();
    }

    public createForm() {
        this.identityForm = this.formBuilder.group(
            {
                checkDigit: [''],
                lastName: [''],
                lastName2: [''],
                name: [''],
                /*        birthLocation: [''],*/
                civilStatus: [''],
                gender: [''],
                birthDate: [''],
                fatherName: [''],
                motherName: [''],
                issueDate: [''],
            });
    }

    public valueDescription(value: string): string {
        switch (value) {
            case 'checkDigit':
                return 'VERIFICATION_DIGIT';
                break;
            case 'lastName':
                return 'LASTNAME_P';
                break;
            case 'lastName2':
                return 'LASTNAME_M';
                break;
            case 'name':
                return 'NAME';
                break;
            /*      case 'birthLocation':
                    return 'UBIGEO_BIRTH';
                    break;*/
            case 'civilStatus':
                return 'CIVIL_STATUS';
                break;
            case 'gender':
                return 'GENDER';
                break;
            case 'birthDate':
                return 'DATE_BIRTH';
                break;
            case 'fatherName':
                return 'NAME_FATHER';
                break;
            case 'motherName':
                return 'NAME_MOTHER';
                break;
            case 'issueDate':
                return 'DATE_ISSUE';
                break;
        }
    }

    public getValue4identityValidation(value: string): string {
        switch (value) {
            case 'checkDigit':
                return this.identityForm.get(value).value;
                break;
            case 'lastName':
                return this.identityForm.get(value).value;
                break;
            case 'lastName2':
                return this.identityForm.get(value).value;
                break;
            case 'name':
                return this.identityForm.get(value).value;
                break;
            /*      case 'birthLocation':
                    return this.identityForm.get(value).value;
                    break;*/
            case 'civilStatus':
                return this.identityForm.get(value).value;
                break;
            case 'gender':
                return this.identityForm.get(value).value;
                break;
            case 'birthDate':
                return NgbDateStructUtil.toString2(this.identityForm.get(value).value);
                break;
            case 'fatherName':
                return this.identityForm.get(value).value;
                break;
            case 'motherName':
                return this.identityForm.get(value).value;
                break;
            case 'issueDate':
                return NgbDateStructUtil.toString2(this.identityForm.get(value).value);
                break;
        }
    }

    public setValidators(value: string) {
        switch (value) {
            case 'checkDigit':
                this.identityForm.get(value).setValidators(Validators.compose([
                    Validators.pattern('^[0-9]{1}'),
                    Validators.required
                ]));
                break;
            case 'lastName':
                this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
                    Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
                break;
            case 'lastName2':
                this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
                    Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
                break;
            case 'name':
                this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
                    Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
                break;
            /*      case 'birthLocation':
                    this.identityForm.get(value).setValidators(Validators.compose([
                      Validators.pattern('^[0-9]{6}'),
                      Validators.required
                    ]));
                    break;*/
            case 'civilStatus':
                this.identityForm.get(value).setValidators(Validators.required);
                break;
            case 'gender':
                this.identityForm.get(value).setValidators(Validators.required);
                break;
            case 'birthDate':
                this.identityForm.get(value).setValidators(Validators.required);
                break;
            case 'fatherName':
                this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
                    Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
                break;
            case 'motherName':
                this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
                    Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
                break;
            case 'issueDate':
                this.identityForm.get(value).setValidators(Validators.required);
                break;
        }
        this.identityForm.get(value).updateValueAndValidity();
        this.listValues.push(value);
    }

    setRequiredFormControl() {
        // tslint:disable-next-line:prefer-const
        for (let index = 0; index < 4;) {
            const value = LocalStorage.getListValueReniec();
            if (this.listValues.filter(a => a === value).length <= 0) {
                this.identityForm.get(value).setValidators(Validators.required);
                this.setValidators(value);
                index++;
            }
        }
    }

    public isInvalidControl(ctrlName: string) {
        return this.identityForm.get(ctrlName).invalid && this.identityForm.get(ctrlName).touched;
    }

    public isNeed4identityValidation(identityValidation: string): boolean {
        return this.listValues.filter(value => value === identityValidation).length > 0;
    }

    public getErrorMessageBy(controlName: string): string {
        const control = this.identityForm.get(controlName);
        const hasRequiredError = control.hasError('required');
        const hasPatternError = control.hasError('pattern');
        switch (controlName) {
            case 'checkDigit':
                if (hasRequiredError) {
                    return this.translate.instant('MESSAGE.ENTER-VERIFY-CODE');
                } else if (hasPatternError) {
                    return this.translate.instant('MESSAGE.FAILED-VERIFY-CODE');
                }
                break;
            case 'lastName':
                if (hasRequiredError) {
                    return this.translate.instant('MESSAGE.FATHERS-LAST-NAME-ARE-REQUIRED');
                } else if (hasPatternError) {
                    return this.translate.instant('MESSAGE.FAILED-LAST-NAME');
                }
                break;
            case 'lastName2':
                if (hasRequiredError) {
                    return this.translate.instant('MESSAGE.MOTHERS-LAST-NAME-ARE-REQUIRED');
                } else if (hasPatternError) {
                    return this.translate.instant('MESSAGE.FAILED-LAST-NAME1');
                }
                break;
            case 'name':
                if (hasRequiredError) {
                    return this.translate.instant('MESSAGE.NAME-IS-REQUIRED');
                } else if (hasPatternError) {
                    return this.translate.instant('MESSAGE.FAILED-NAME');
                }
                break;
            /*      case 'birthLocation':
                    if (hasRequiredError) {
                      return this.translate.instant('MESSAGE.ENTER-BIRTH-LOCATION');
                    } else if (hasPatternError) {
                      return this.translate.instant('MESSAGE.FAILED-BIRTH-LOCATION');
                    }
                    break;*/
            case 'civilStatus':
                break;
            case 'gender':
                break;
            case 'birthDate':
                return this.translate.instant('MESSAGE.ENTER-BIRTH-DATE');
                break;
            case 'fatherName':
                if (hasRequiredError) {
                    return this.translate.instant('MESSAGE.ENTER-FATHER-NAME');
                } else if (hasPatternError) {
                    return this.translate.instant('MESSAGE.FAILED-FATHER-NAME');
                }
                break;
            case 'motherName':
                if (hasRequiredError) {
                    return this.translate.instant('MESSAGE.ENTER-MOTHER-NAME');
                } else if (hasPatternError) {
                    return this.translate.instant('MESSAGE.FAILED-MOTHER-NAME');
                }
                break;
            case 'issueDate':
                return this.translate.instant('MESSAGE.ENTER-ISSUE-DATE');
                break;
        }
    }

    showMessage(alert: string, icon: string, message: any) {
        this.alertType = alert;
        this.messageAlert = message;
        this.icon = icon;
    }

    closeAlert() {
        const alertElement = document.getElementById('customAlert');
        alertElement.style.display = 'none';
        alertElement.style.visibility = 'none';
    }
}
